var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{staticClass:"app-footer"},[_vm._v(" Beepay © "+_vm._s(new Date().getFullYear())+" Created by Beepay-fontend ")])}
var staticRenderFns = []

export { render, staticRenderFns }